import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Sidebar from './components/sidebar';
import Footer from './components/footer';
import routesArray from './routes'; // Importar las rutas del archivo routes.js
import Login from './views/login'; // Vista de inicio de sesión
import { ToastContainer } from 'react-toastify';
import './App.css';
import imageUser from './img/profe (1).png';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  // Función para alternar el tema entre claro y oscuro
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme); // Guardar el tema en localStorage
  };

  const currentUser = {
    userName: 'John Doe',
    urlImage: imageUser,
  };

  useEffect(() => {
    // Aplicar el atributo data-bs-theme al body cada vez que el tema cambie
    document.body.setAttribute('data-bs-theme', theme);
  }, [theme]);

  const handleLogin = (data) => {
    localStorage.setItem('token', data.token);
    setIsAuthenticated(true);
  };

  const cerrarSession = () => {
    localStorage.clear();
    setIsAuthenticated(false);
  };

  return (
    <Router>
      {isAuthenticated ? (
        <div className="wrapper">
          <Sidebar />
          <div className="main">
            <Header
              cerrarSession={cerrarSession}
              toggleTheme={toggleTheme}
              theme={theme}
              user={currentUser} // Pasa el objeto del usuario actual
            />
            <main className="content" id="mainContainer">
              <Routes>
                {routesArray.map((route) => route)}
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<Login onLogin={handleLogin} />} />
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
        </Routes>
      )}
      <ToastContainer />
    </Router>
  );
}

export default App;
